"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColunaFormulario = void 0;
var react_1 = __importDefault(require("react"));
var FormularioGrid_1 = require("../FormularioGrid/FormularioGrid");
var ColunaFormulario = function (_a) {
    var id = _a.id, _b = _a.width, width = _b === void 0 ? 100 : _b, _c = _a.height, height = _c === void 0 ? "100%" : _c, minHeight = _a.minHeight, children = _a.children, _d = _a.className, className = _d === void 0 ? "" : _d, style = _a.style;
    return (react_1.default.createElement(FormularioGrid_1.FormularioGrid, { style: style, id: id, className: className, tipo: "column", width: width, height: height, minHeight: minHeight }, children));
};
exports.ColunaFormulario = ColunaFormulario;
